import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import './addNewPage.css';
import Lightbox from './../../../lightbox/Lightbox';
import {
  createPage,
  setIsActive,
  setLayoutToActivePage,
} from './../../../../redux/actions/entities/pages';
import {
  isImageInChange,
  convertObjectToArray,
  orderBy,
  GetActivePage,
  showAlertModal,
} from './../../../../redux/helpers';
import { imageChange } from './../../../../redux/actions/ui/imageChange';
import { getLayoutsByType } from './../../../../redux/helpers/layouts';
import { generateBabyBookTexts } from './../../../../helpers/babyBookHelper';
import { userTextsGenerated, setModalStatus } from './../../../../redux/actions/ui/babyPage';

class AddNewPage extends Component {
  constructor(props) {
    super(props);
    this.insertNewPage = debounce(this.insertNewPage, 200);
    this.state = {
      addNewPage: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      layoutsById,
      pages,
      isChange,
      userTextsAlreadyGenerated,
      dispatch,
    } = this.props;

    const { pages: thisPages } = prevProps;

    if (isChange === this.props.isChange) {
      if (thisPages.length !== pages.length) {
        const [pageId] = pages.slice(-1);

        if (this.state.addNewPage) {
          this.props.dispatch(setIsActive(pageId));
        }
        // Load all layout
        let layoutsArray = convertObjectToArray(layoutsById).filter(layout => !layout.isCover && !layout.isBackFlyleaf && !layout.isFrontFlyleaf);
        if (this.state.addNewPage) {
          if (pages.length > thisPages.length) {
            this.props.dispatch(imageChange(true));
          }
          if (thisPages.length < pages.length) {
            this.setState({
              addNewPage: false,
            }, () => {
              // Load babyLayout on first page (babyBookOnly)
              const activePage = GetActivePage(this.props.pagesById);
              if (activePage.isBabyPage) {
                layoutsArray = getLayoutsByType(layoutsById, 'isBabyPlaceholder');
              }
              const ordered = orderBy(layoutsArray, 'order');
              const [layoutId] = ordered.slice(0);
              this.props.dispatch(setLayoutToActivePage(layoutId.id, pageId, false, false));
              if (activePage.isBabyPage) {
                setTimeout(() => {
                  generateBabyBookTexts(this.props.dispatch);
                }, 0);
              }
            });
          }
        }
      }
    }

    if (userTextsAlreadyGenerated !== undefined && userTextsAlreadyGenerated) {
      dispatch(userTextsGenerated(false));
      dispatch(setModalStatus(true));
    }
  }

  getArrayProperty = (array, property) => Object.values(array).find(element => element[property]);

  insertNewPage() {
    const {
      pagesById,
      isChange,
      pages,
      lang,
      maxSheets,
    } = this.props;


    const currentIsCover = GetActivePage(pagesById).isCover;
    if (isImageInChange(isChange, currentIsCover, lang)) {
      return;
    }

    if (pages.length <= maxSheets) {
      setTimeout(() => {
        this.props.dispatch(createPage(this.page));
        this.setState({
          addNewPage: true,
        });
      }, 0);
    } else {
      showAlertModal(lang.title_notice, lang.no_more_pages);
    }

    this.setState({
      addNewPage: true,
    });
  }


  isBabyBook() {
    const { pagesById, layoutsById, isBabyBook } = this.props;
    const hasBabyPage = this.getArrayProperty(pagesById, 'isBabyPage');
    const hasBabyLayout = this.getArrayProperty(layoutsById, 'isBabyPlaceholder');
    return hasBabyPage === undefined && hasBabyLayout !== undefined && isBabyBook;
  }

  render() {
    const {
      pagesById,
      pages,
      pageBackgroundColor,
      lang,
      maxSheets,
      pageBackgroundImage,
      pageBackgroundImageFull,
      sizes,
      babyModalVisible,
      setDefaultTexts,
      bookHeight,
      layoutHeight,
      bookRatio,
      texts,
      bookId,
      setModalStatus,
    } = this.props;

    const isBack = this.getArrayProperty(pagesById, 'isBackFlyLeaf');


    const order = isBack !== undefined ? pages.length - 1 : pages.length;
    this.page = {
      preview: '',
      layout: 0,
      placeholders: [],
      order,
      isActive: false,
      isCover: false,
      isBabyPage: this.isBabyBook(),
      texts: [],
      backgroundColor: pageBackgroundImage !== '' ? null : pageBackgroundColor,
      backgroundImages: {
        thumbnail: pageBackgroundImage,
        full: pageBackgroundImageFull,
        sizes,
      },
    };

    const activePage = GetActivePage(this.props.pagesById);
    const [pageId] = pages.slice(-1);
    const bookProps = {
      bookHeight,
      layoutHeight,
      bookRatio,
      pageBackgroundImage,
      bookId,
    };

    return (
      <div>
        { babyModalVisible && setDefaultTexts && activePage.isBabyPage && !setModalStatus &&
        /* Show Baby modal in baby page only */
          <Lightbox
            isForm
            lang={lang}
            dispatch={this.props.dispatch}
            pageId={pageId}
            bookProps={bookProps}
            texts={texts}
            bookHeight={bookHeight}
            layoutHeight={layoutHeight}
          />
        }

        <div className={`add-page ${pages.length === maxSheets ? 'not-allowed' : ''}`}>
          <button className="green-btn" onClick={() => this.insertNewPage()}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.5,8.5h-4v4h-1v-4h-4v-1h4v-4h1v4h4Z" />
            </svg>
            {lang.top_menu_new_page}
          </button>
        </div>
      </div>
    );
  }
}

AddNewPage.defaultProps = {
  pageBackgroundColor: '',
  pageBackgroundImage: '',
  isChange: false,
  layoutsById: {},
  pages: [],
  maxSheets: 0,
  texts: {},
  lang: {},
  dispatch: () => {},
  pagesById: {},
  pageBackgroundImageFull: '',
  bookRatio: 1,
  bookHeight: 0,
  layoutHeight: 300,
  setDefaultTexts: false,
  babyModalVisible: false,
  setModalStatus: false,
  isBabyBook: false,
};

AddNewPage.propTypes = {
  pageBackgroundColor: PropTypes.string,
  pageBackgroundImage: PropTypes.string,
  isChange: PropTypes.bool,
  layoutsById: PropTypes.object,
  pages: PropTypes.array,
  maxSheets: PropTypes.number,
  texts: PropTypes.object,
  pageBackgroundImageFull: PropTypes.string,
  lang: PropTypes.object,
  dispatch: PropTypes.func,
  pagesById: PropTypes.object,
  bookRatio: PropTypes.number,
  bookHeight: PropTypes.number,
  layoutHeight: PropTypes.number,
  setDefaultTexts: PropTypes.bool,
  babyModalVisible: PropTypes.bool,
  setModalStatus: PropTypes.bool,
  isBabyBook: PropTypes.bool,
};

export default connect(state => ({
  layouts: state.entities.layouts.allIds,
  layoutsById: state.entities.layouts.byId,
  maxSheets: state.bookProperties.maxSheets,
  bookRatio: state.bookProperties.bookSizes.ratio,
  texts: state.entities.texts,
  layoutHeight: state.bookProperties.dimensions.layoutHeight,
  bookHeight: state.bookProperties.bookSizes.height,
  setDefaultTexts: state.editorUI.babyPageProperties.setDefaultTexts,
  babyModalVisible: state.editorUI.babyPageProperties.setModalVisible,
  userTextsAlreadyGenerated: state.editorUI.babyPageProperties.userTextsGenerated,
  setModalStatus: state.editorUI.babyPageProperties.modalClosed,
  isBabyBook: state.bookProperties.isBabyBook,
}))(AddNewPage);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/add-new-page/addNewPage.jsx